import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  footerLinks: { label: string; route: string }[] = [
    { label: 'Privacy Policy', route: '/policies/privacy' },
    { label: 'Help', route: '/policies/privacy' },
    { label: 'Contact', route: '/policies/contact' },
  ];
}